

import React from "react";
import {
  Box,
  useDisclosure,
  Drawer,
  DrawerContent,
  Flex,

} from "@chakra-ui/react";


import SidebarContent from "./SidebarContent";
import MobileNav from "./MobileNav";
import { Outlet } from "react-router-dom";
import Footer from "./Footer";
import MusicPlayer from "../Home/MusicPlayer";
import { useMusicPlayer } from "../../context/MusicPlayerContext";
import { useBanner } from "../../context/BannerContext";

const NavBar = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { currentTrack } = useMusicPlayer()
  const {isVisible} = useBanner()



  return (
    <Box minH="100vh" maxW="1450px" display="flex" flexDirection="column" m="auto" >
      {/* <SidebarContent onClose={() => onClose} display={{ base: 'none', md: 'block' }} /> */}

      <Drawer
        isOpen={isOpen}
        placement="right"
        onClose={onClose}
        returnFocusOnClose={true}
        onOverlayClick={onClose}
        size="full">
        <DrawerContent>
          <SidebarContent onClose={onClose} />
        </DrawerContent>
      </Drawer>
      {/* mobilenav */}

      <MobileNav onOpen={onOpen} />
      {
        currentTrack && (
          <Box mt={2} h="10vh" zIndex={2} position="fixed" top={{ base: "17vh", md: "15vh" }} left={0} right={0} transform={currentTrack ? "translateY(0)" : "translateY(20px)"} transition="all 0.3s ease" >
            <MusicPlayer/>
          </Box>
        )
      }

      <Flex direction="column" flex="1">
        <Box transition="margin-top 1s ease"  flex="1" mb={{ base: "600px", lg: "400px" }} mt={{ base: currentTrack || isVisible ? "27vh" : "15vh", md: currentTrack || isVisible ? "23vh" : "15vh" }} p="1.5rem">
          <Outlet />
        </Box>
        <Footer />
      </Flex>
    </Box>
  );
};

export default NavBar;
